document.addEventListener('DOMContentLoaded', () => {
  if(window.innerWidth <= 991){
    gsap.registerPlugin(ScrollTrigger);
    let currentNum = 0;
    let animating = false;
    let intentObserver;
    let preventScroll;
    let swipePanels = gsap.utils.toArray(".cs-slider");
    gsap.set(swipePanels, { yPercent: 100 });
    gsap.set(swipePanels[0], { yPercent: 0 });
    intentObserver = ScrollTrigger.observe({
      type: "wheel,touch",
      onUp: () => !animating && gotoPanel(currentNum + 1),
      onDown: () => !animating && gotoPanel(currentNum - 1),
      preventDefault: true,
    });
    intentObserver.disable();
    preventScroll = ScrollTrigger.observe({
      type: "wheel,scroll",
      preventDefault: true,
      allowClicks: true,
      onEnable: (self) => (self.savedScroll = self.scrollY()),
      onChangeY: (self) => self.scrollY(self.savedScroll),
      capture: true,
      passive: false
    });
    preventScroll.disable();
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector('body').classList.toggle('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        input_box();
        intentObserver.disable();
        preventScroll.disable();
        document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
          cartButton.addEventListener('click',function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
            createdUlElements.forEach(ul => ul.remove());
            if(document.querySelector('body').classList.contains('open-quick-buy') && document.querySelector('body').classList.contains('open-drawer')){
              document.querySelector('body').classList.remove('open-quick-buy','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro');
            }else{
              document.querySelector('body').classList.remove('open-quick-buy','open-drawer','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro');
            }
            preventScroll.enable();
            intentObserver.enable();
          });
        });
      });
    });
    if(document.querySelectorAll('#md-app-embed__modal .md-modal__container .md-form__select')) document.querySelectorAll('#md-app-embed__modal .md-modal__container .md-form__select').forEach(function(select_app_model){
      select_app_model.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        intentObserver.disable();
        preventScroll.disable();
      });
    });
    if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
      menuBurger.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        if(window.innerWidth > 991){
          if(document.body.classList.contains('open-search') || document.body.classList.contains('open-mobile-search') || document.body.classList.contains('active-acc')){
            document.body.classList.remove('open-mobile-search','active-acc');
          }
          document.body.classList.toggle('open-menu');
        }else{
          if(document.body.classList.contains('open-search') || document.body.classList.contains('open-mobile-search') || document.body.classList.contains('active-acc')){
            document.body.classList.remove('open-mobile-search','active-acc');
          }else{
            document.body.classList.toggle('open-menu');
          }
        }
        document.body.classList.remove('open-drawer','open-search','open-sort','open-filter','menu-link-clicked');
        if(document.body.classList.contains('open-menu')){
          intentObserver.disable();
          preventScroll.disable();
        }else{
          preventScroll.enable();
          intentObserver.enable();
        }
      });
    });
    function disableBodyScroll() {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
    function enableBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    document.addEventListener('touchmove', function (event) {
      if (document.body.classList.contains('scroll-blocked')) {
        event.preventDefault();
      }
    }, { passive: false });
    function gotoPanel(index) {
      if (index < 0 || index >= swipePanels.length || animating) {
        if (index >= swipePanels.length) {
          intentObserver.disable();
          preventScroll.disable();
          enableBodyScroll();
        }
        return;
      }
      
      animating = true;
      let isScrollingDown = index > currentNum;
      let currentPanel = swipePanels[currentNum];
      let targetPanel = swipePanels[index];
      
      document.querySelectorAll('.cs-cont-inr').forEach(cont => cont.classList.remove('active'));
      document.querySelectorAll('.cs-cont-inr')[index].classList.add('active');
      document.querySelectorAll('.cs-dots li').forEach((cont_dot_rm) => cont_dot_rm.classList.remove('active'));
      document.querySelectorAll('.cs-dots li')[index].classList.add('active');
    
      gsap.timeline({
        defaults: { ease: "power4.out", duration: 0.85 }, // Smoother easing
        onComplete: () => {
          animating = false;
          currentNum = index;
          if (index === swipePanels.length - 1) {
            enableBodyScroll();
          }
        },
      })
      .to(currentPanel, {
        yPercent: isScrollingDown ? 0 : 100,
      })
      .to(targetPanel, {
        yPercent: 0,
      }, "<");
      if(!isScrollingDown){
        gsap.set(targetPanel, { yPercent: 0 });
      }
    
      swipePanels.forEach((panel, i) => {
        if(i !== index && i !== currentNum){
          gsap.set(panel, { yPercent: 100 });
        }
      });
    }
    ScrollTrigger.create({
      trigger: ".contradirectional-slider",
      pin: '.section-contradirectional-slider',
      anticipatePin: true,
      start: "top top",
      end: "+=10%",
      onEnter: (self) => {
        if (!preventScroll.isEnabled) {
          self.scroll(self.start);
          preventScroll.enable();
          intentObserver.enable();
          disableBodyScroll();
        }
      },
      onLeave: (self) => {
        if(currentNum === swipePanels.length - 1){
          enableBodyScroll();
        }
      },
      onEnterBack: (self) => {
        if(!preventScroll.isEnabled){
          self.scroll(self.start);
          preventScroll.enable();
          intentObserver.enable();
          disableBodyScroll();
        }
      },
      onLeaveBack: (self) => {
        if(!preventScroll.isEnabled){
          preventScroll.enable();
          intentObserver.enable();
          disableBodyScroll();
        }
      }
    });
  }else{
    document.querySelector('.header-logo a').addEventListener('click', (e) => {
      sessionStorage.removeItem('lastActiveSlide');
      swiper.slideTo(0);
      document.querySelectorAll('.cs-slider').forEach(slide => slide.classList.remove('is-active'));
      document.querySelectorAll('.cs-cont-inr').forEach(cont => cont.classList.remove('active'));
      document.querySelectorAll('.cs-slider')[0].classList.add('is-active');
      document.querySelectorAll('.cs-cont-inr')[0].classList.add('active');
      gsap.set('.cs-slider-left', { y: '0%' });
      gsap.set('.cs-slider-rgt', { y: '0%' });
      ScrollTrigger.refresh();
    });
    let enable_scrolling = true;
    const lastSlideIndex = sessionStorage.getItem('lastActiveSlide') ? parseInt(sessionStorage.getItem('lastActiveSlide')) : 0;
    const swiper = new Swiper('.contradirectional-slider', {
      direction: 'vertical',
      speed: 2000,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: false,
      initialSlide: lastSlideIndex,
    });
    setTimeout(() => {
      const activeSlide = document.querySelectorAll('.cs-slider')[lastSlideIndex];
      document.querySelectorAll('.cs-slider').forEach(slide => slide.classList.remove('is-active'));
      document.querySelectorAll('.cs-cont-inr').forEach(cont => cont.classList.remove('active'));
      activeSlide.classList.add('is-active');
      document.querySelectorAll('.cs-cont-inr')[lastSlideIndex].classList.add('active');
      gsap.set(activeSlide.querySelector('.cs-slider-left'), { y: '0%' });
      gsap.set(activeSlide.querySelector('.cs-slider-rgt'), { y: '0%' });
      document.querySelectorAll('.cs-slider').forEach(slide => slide.style.zIndex = 0);
      activeSlide.style.zIndex = 2;
      ScrollTrigger.refresh();
    }, 100);
    let isAnimating = false;
    let body_width = document.body.offsetWidth;
    let out_to_section = false;
    let last_slide = true;
    let last_element = false;
    swiper.on('slideChange', function(){
      const newIndex = swiper.activeIndex;
      const oldIndex = swiper.previousIndex;
      if (isAnimating) return;
      isAnimating = true;
      sessionStorage.setItem('lastActiveSlide', newIndex);
      document.querySelectorAll('.cs-slider').forEach(slide => slide.classList.remove('is-active'));
      document.querySelectorAll('.cs-cont-inr').forEach(cont => cont.classList.remove('active'));
      document.querySelectorAll('.cs-slider')[newIndex].classList.add('is-active');
      document.querySelectorAll('.cs-cont-inr')[newIndex].classList.add('active');
      const currentSlide = document.querySelectorAll('.cs-slider')[oldIndex];
      const nextSlide = document.querySelectorAll('.cs-slider')[newIndex];
      const totalSlides = swiper.slides.length;
      document.querySelectorAll('.cs-slider').forEach((slide) => {
        slide.style.zIndex = 0;
      });
      const direction = newIndex > oldIndex ? 'down' : 'up';
      const tl = gsap.timeline({
        onComplete: () => {
          if(direction === 'down'){
            if(newIndex === totalSlides - 1){
              out_to_section = true;
              last_slide = true;
              last_element = true;
            }else{
              last_slide = true;
              last_element = false;
            }
            document.removeEventListener('wheel', handleWheel);
            document.querySelector('body').classList.remove('start_anim');
          }else{
            last_element = false;
            currentSlide.style.zIndex = 1;
            nextSlide.style.zIndex = 2;
            if(newIndex === totalSlides - 1){
              document.querySelector('body').classList.add('start_anim');
              document.addEventListener('wheel', handleWheel, { passive: false });
            }
          }
          setTimeout(() => {
            isAnimating = false;
          }, 500);
        },
      });
      if (direction === 'down'){
        currentSlide.style.zIndex = 1;
        nextSlide.style.zIndex = 2;
        tl.to(currentSlide.querySelector('.cs-slider-left'), {
          y: '0%',
          duration: 0.8,
          ease: 'power3.out',
        })
        .to(
          currentSlide.querySelector('.cs-slider-rgt'),
          {
            y: '0%',
            duration: 0.8,
            ease: 'power3.out',
          },
          '<'
        )
        .fromTo(
          nextSlide.querySelector('.cs-slider-left'),
          { y: '-100%' },
          { y: '0%', duration: 0.8, ease: 'power3.out' },
          '<'
        )
        .fromTo(
          nextSlide.querySelector('.cs-slider-rgt'),
          { y: '100%' },
          { y: '0%', duration: 0.8, ease: 'power3.out' },
          '<'
        );
      } else {
        currentSlide.style.zIndex = 2;
        nextSlide.style.zIndex = 1;
        tl.to(currentSlide.querySelector('.cs-slider-left'), {
          y: '-100%',
          duration: 0.8,
          ease: 'power3.out',
        })
        .to(
          currentSlide.querySelector('.cs-slider-rgt'),
          {
            y: '100%',
            duration: 0.8,
            ease: 'power3.out',
          },
          '<'
        )
        .fromTo(
          nextSlide.querySelector('.cs-slider-left'),
          { y: '0%' },
          { y: '-0%', duration: 0.8, ease: 'power3.out' },
          '<'
        )
        .fromTo(
          nextSlide.querySelector('.cs-slider-rgt'),
          { y: '0%' },
          { y: '0%', duration: 0.8, ease: 'power3.out' },
          '<'
        );
        
      }
    });
    // const handleWheel = (event) => {
    //   let scrollCount = window.pageYOffset;
    //   if(scrollCount >= document.querySelector('.contradirectional-slider').offsetTop){
    //     document.querySelector('body').classList.add('start_anim');
    //   }
    //   if (isAnimating) return;
    //   if (event.deltaY > 0) {
    //       swiper.slideNext();
    //   } else if (event.deltaY < 0) {
    //       swiper.slidePrev();
    //   }
    // };

    let scrollThreshold = 100;
    let scrollDelta = 0;
    const handleWheel = (event) => {
      if (isAnimating) return;
      scrollDelta += event.deltaY;
      if (Math.abs(scrollDelta) > scrollThreshold) {
        if(scrollDelta > 0){
          swiper.slideNext();
        }else{
          swiper.slidePrev();
        }
        scrollDelta = 0;
      }
    };
    
    document.addEventListener("wheel", (event) => {
      const section = document.querySelector('.contradirectional-slider');
      let last_active = false;
      if(event.deltaY > 0){
        if(document.querySelectorAll('.cs-slider')[document.querySelectorAll('.cs-slider').length - 1].classList.contains('swiper-slide-active')){
          if(last_element){
            if(last_slide){
              document.removeEventListener('wheel', handleWheel);
              document.querySelector('body').classList.remove('start_anim');
            }
          }
        }
        out_to_section = false;
      }else{
        if(document.querySelectorAll('.cs-slider')[document.querySelectorAll('.cs-slider').length - 1].classList.contains('is-active')){
          last_active = true;
        }
        if(section.getBoundingClientRect().top >= 0){
          if(!out_to_section){
            document.querySelector('body').classList.add('start_anim');
            setTimeout(() => {
              document.addEventListener('wheel', handleWheel, { passive: false });
            }, 1000);
          }else{
            document.querySelector('body').classList.add('start_anim');
            document.addEventListener('wheel', handleWheel, { passive: false });
          }
        }
      }
    });
    var lastScroll = 0;
    window.addEventListener('scroll', function(event){
      const section = document.querySelector('.contradirectional-slider');
      const getSectionAttribute = section.getAttribute('data-slider');
      var scrollTop = window.scrollY;
      var sectionOffsetTop = section.offsetTop;
      var sectionHeight = section.offsetHeight;
      let scrollCount = window.pageYOffset;
      var windowHeight = window.innerHeight;
      setTimeout(function(){
        if(scrollCount > lastScroll){
          swiper.on('slideChange', function () {
            const newIndex = swiper.activeIndex;
            const oldIndex = swiper.previousIndex;
            if(newIndex == 0){
              document.querySelector('body').classList.add('start_anim');
            }
          })
        }else if(scrollCount < lastScroll){
          if(section.getBoundingClientRect().top >= 0){
            document.querySelector('body').classList.add('start_anim');
            setTimeout(() => {
              document.addEventListener('wheel', handleWheel, { passive: false });
            }, 1000);
          }
        }
        lastScroll = scrollCount;
      }, 0);
      if(scrollTop < sectionOffsetTop){
        if(getSectionAttribute === 'false'){
          document.scrollingElement.scrollTop = sectionOffsetTop;
        }
      }else if(scrollTop > sectionOffsetTop + sectionHeight - windowHeight){
        if(parseInt(document.querySelector('.cs-cont-inr.active').getAttribute('data-val')) != document.querySelectorAll('.cs-cont-inr').length){
          if(getSectionAttribute === 'true'){
            if(enable_scrolling){
              document.scrollingElement.scrollTop = sectionOffsetTop;
              document.addEventListener('wheel', handleWheel, { passive: false });
            }
          }
        }
      }
    }, { passive: false });
    if(performance.navigation.type === 1){
      sessionStorage.removeItem('lastActiveSlide');
    }
  }
});